import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import ProductTypesList from './../product-types/ProductTypesList';

const ProductTypesSettingsPage: React.FC = () => {

    const pageHeader = {
        title: 'Ajustes de Tipos de Productos',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Tipos de Productos', href: menuRoutes.settings.path + menuRoutes.settings.product_types },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />

            <div className="p-6">
                <ProductTypesList />
            </div>
        </div>
    );
};

export default ProductTypesSettingsPage;